import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Slide,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import activeSaleforceLogo from "../../../Assets/activeSaleforceLogo.svg";
import decisionMakerImage from "../../../Assets/Cloudfigma.svg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RightSidebarMobile from "../../RightSiderbar/RightSidebarMobile";
import visitLinkImage from "../../../Assets/visit-link.svg";
import {
  APIUrlThree,
  APIUrlToken,
  APIUrlTwo,
  GetUserId,
} from "../../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../Loader/Loader";

const MLeadsProspectsInnerTable = ({
  openTableDrawer,
  setOpenTableDrawer,
  isTabPortrait,
  onSelect,
  selectedRows,
}) => {
  const [data, setData] = useState([]);
  const [openMSidebarDrawer, setOpenMSidebarDrawer] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const userId = GetUserId();
  const perPage = 50;
  const [skip, setSkip] = React.useState(0);

  const [hasMore, setHasMore] = useState(false);

  const handlePassSubmit = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/decision_maker?org_id=${
        openTableDrawer?.org_id
      }&limit=${perPage}&skip=${skip ? skip : 0}`,
    };
    axios(option)
      .then((e) => {
        if (e?.status === 200) {
          getStrength(e?.data?.data);
          toast.success(e?.data?.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const getStrength = async (childData) => {
    if (!childData?.length) {
      setLoading(false);
      return;
    }

    const tuples = childData?.map((item) => ({
      items: [userId?.toString(), item.person_id?.toString()],
    }));
    const data = { tuples };
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlTwo()}/v1/conn_strength`,
    };

    try {
      const response = await axios(options);
      const strengthData = response?.data;

      const updatedData = childData?.map((item, index) => ({
        ...item,
        strengthData: strengthData[index],
      }));
      const comingData = updatedData?.sort(
        (a, b) => (b.decision_maker ? 1 : 0) - (a.decision_maker ? 1 : 0),
      );
      if (comingData.length === 0 || comingData.length % 50 !== 0) {
        setHasMore(false);
      } else {
        setTimeout(() => {
          setHasMore(true);
        }, 1000);
      }
      if (skip > 0) {
        setData((prevdata) => [...prevdata, ...comingData]);
      } else {
        setData(comingData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    }
  };
  useEffect(() => {
    if (skip > 0 || openTableDrawer?.org_id) {
      handlePassSubmit();
    }
  }, [openTableDrawer?.org_id, skip]);
  return (
    <>
      {loading ? <Loader /> : null}
      <Slide
        direction="left"
        in={openTableDrawer?.org_id}
        mountOnEnter
        unmountOnExit
        className="aip-filter-mb-slide"
      >
        <Box
          sx={{
            position: "fixed",
            top: isTabPortrait ? "33px" : "0",
            left: isTabPortrait ? "" : "0",
            right: isTabPortrait ? "0px" : "",
            width: isTabPortrait ? "calc(100vw - 240px)" : "100vw",
            bgcolor: "white",
            zIndex: 10,
            boxShadow: 2,
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            overflowX: "hidden",
            overflowY: "auto",
            pb: 20,

          }}
        >
          <div className="p-2 aip-path-slide-box">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              py={1.5}
            >
              <IconButton></IconButton>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                style={{ textTransform: "capitalize" }}
              >
                {openTableDrawer?.name}
              </Typography>
              <IconButton onClick={() => setOpenTableDrawer()}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <div>
              {data?.map((row) => {
                const isSelected = selectedRows?.some(
                  (item) => item?.person_id === row?.person_id,
                );

                return (
                  <Card
                    key={row?.person_id}
                    sx={{
                      borderRadius: 3,
                      boxShadow: 2,
                      mb: 2,
                      backgroundColor: isSelected ? "#c0dae6" : "#fff",
                      cursor: "pointer",
                    }}
                    // onClick={() => onSelect(row)}
                  >
                    <CardContent>
                      {/* Header */}
                      <Grid container alignItems="center" spacing={0.5}>
                        <Grid item>
                          <div
                            className={
                              row?.decision_maker === true
                                ? "Decision-maker-user-name"
                                : "Decision-maker-user-noborder create-name-img"
                            }
                          >
                            <img
                              className={
                                row?.suspect_status === null
                                  ? "hide-image"
                                  : row?.journey_status === "project created"
                                    ? "decisionMakerImageAi-Decisionmaker-green"
                                    : "decisionMakerImageAi-Decisionmaker"
                              }
                              src={
                                row?.journey_status === "project created"
                                  ? activeSaleforceLogo
                                  : decisionMakerImage
                              }
                              alt=""
                            />
                            <p className="letter-heading">
                              {row?.first_name
                                ? row?.first_name
                                    ?.split(" ")
                                    ?.find((item) => !item.includes("("))
                                    ?.charAt(0)
                                : ""}
                              {row?.last_name
                                ? row?.last_name
                                    ?.split(" ")
                                    ?.find((item) => !item.includes("("))
                                    ?.charAt(0)
                                : ""}
                            </p>
                          </div>
                        </Grid>
                        <Grid item xs>
                          <Typography
                            onClick={() => onSelect(row)}
                            variant="subtitle1"
                            fontWeight="bold"
                            
                            style={{ textTransform: "capitalize" ,paddingLeft:"10px"}}
                          >
                            {row?.first_name === "jp"
                              ? "JP"
                              : row?.first_name || "---"}
                            &nbsp;
                            {row?.last_name ? row?.last_name : "---"}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            <div className="job-title-container">
                              <div className="tooltip-container-jobtitle">
                                <p
                                  className={
                                    row?.raw_job_title
                                      ? "tooltip-highlights-jobtitle"
                                      : "tooltip-highlights-jobtitle-none"
                                  }
                                >
                                  {row?.raw_job_title}
                                </p>
                                <p className="after-company-name-country-fordecisionmaker">
                                  {row?.primary_job_title
                                    ? row.primary_job_title.substring(0, 18) +
                                      (row.primary_job_title.length > 18
                                        ? "..."
                                        : "")
                                    : "---"}
                                </p>
                              </div>
                            </div>
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Box display="flex" alignItems="center" gap={1}>
                            {/* <StarBorderIcon fontSize="small" sx={{ color: "grey.600" }} /> */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                bgcolor: "#f5f6f8",
                                borderRadius: "50px",
                                px: 1.2,
                                py: 0.3,
                              }}
                            >
                              <Typography
                                variant="body2"
                                fontWeight={500}
                                color="text.primary"
                              >
                                {row?.strengthData?.strength
                                  ? row?.strengthData?.strength
                                  : "---"}
                              </Typography>
                            </Box>
                            {row?.strengthData?.strength === 0 ||
                            row?.strengthData?.strength === "---" ? (
                              <IconButton
                                size="small"
                                sx={{
                                  bgcolor: "hsl(220deg 4.04% 64.98%)",
                                  "&:hover": {
                                    bgcolor: "hsl(220deg 4.04% 64.98%)",
                                  },
                                }}
                              >
                                <ArrowForwardIosIcon
                                  fontSize="small"
                                  sx={{ color: "red" }}
                                />
                              </IconButton>
                            ) : (
                              <IconButton
                                size="small"
                                sx={{
                                  bgcolor: "#f5f6f8",
                                  "&:hover": { bgcolor: "#eaeaea" },
                                }}
                              >
                                <ArrowForwardIosIcon
                                  fontSize="small"
                                  sx={{ color: "red" }}
                                  onClick={() => {
                                    setOpenMSidebarDrawer(row);
                                    window.scrollTo(0, 0);
                                  }}
                                />
                              </IconButton>
                            )}
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Info Rows */}
                      <Box mt={2}>
                        <Grid container spacing={1}>
                          <Grid item xs={6}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Organization
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{ textTransform: "capitalize" }}
                            >
                              {row.primary_organization
                                ? row.primary_organization
                                : "---"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Industry
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{ textTransform: "capitalize" }}
                            >
                              {row?.categories}
                              {/* <IndustryDropdown row={row} /> */}
                            </Typography>
                          </Grid>

                          <Grid item xs={6}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              JOSF Status
                            </Typography>
                            <Typography variant="body2">
                              {" "}
                              {row?.suspect_status ? row.suspect_status : "---"}
                            </Typography>
                          </Grid>
                          {/* <Grid item xs={6}>
                          <Typography variant="caption" color="text.secondary">
                            Contact Details
                          </Typography>
                          {row?.linkedin ? (
                            <Typography
                              variant="body2"
                              style={{ display: "flex", gap: "5px" }}
                            >
                              {row?.linkedin.length > 28
                                ? row?.linkedin.substr(28, 22)
                                : row?.linkedin}
                              <span
                                onClick={() =>
                                  row?.linkedin && window?.open(row?.linkedin)
                                }
                              >
                                <img src={visitLinkImage} alt="" />
                              </span>
                            </Typography>
                          ) : (
                            ""
                          )}
                          {row?.email ? (
                            <Typography variant="body2">
                              {row?.email.length > 18
                                ? row?.email.substr(0, 18) + "..."
                                : row?.email}
                            </Typography>
                          ) : (
                            ""
                          )}
                          {row?.phone_no ? (
                            <Typography variant="body2">
                              {row?.phone_no.length > 22
                                ? row?.phone_no.substr(0, 22) + "..."
                                : row?.phone_no}
                            </Typography>
                          ) : (
                            ""
                          )}
                        </Grid> */}
                          <Grid item xs={6}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Contact Details
                            </Typography>

                            {/* LinkedIn */}
                            <Typography
                              variant="body2"
                              style={{
                                display: "flex",
                                gap: "5px",
                                alignItems: "center",
                              }}
                            >
                              {row?.linkedin
                                ? row.linkedin.length > 28
                                  ? row.linkedin.substr(28, 22)
                                  : row.linkedin
                                : "---"}

                              {row?.linkedin && (
                                <span onClick={() => window.open(row.linkedin)}>
                                  <img src={visitLinkImage} alt="" />
                                </span>
                              )}
                            </Typography>

                            {/* Email */}
                            <Typography variant="body2">
                              {row?.email
                                ? row.email.length > 18
                                  ? row.email.substr(0, 18) + "..."
                                  : row.email
                                : "---"}
                            </Typography>

                            {/* Phone */}
                            <Typography variant="body2">
                              {row?.phone_no
                                ? row.phone_no.length > 22
                                  ? row.phone_no.substr(0, 22) + "..."
                                  : row.phone_no
                                : "---"}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </CardContent>
                  </Card>
                );
              })}
              <RightSidebarMobile
                openSidebar={openMSidebarDrawer}
                setOpenSidebar={setOpenMSidebarDrawer}
                isTabPortrait={isTabPortrait}
              />
              <div className="loadmore-pagination-section">
                {hasMore && (
                  <button
                    className="btn-load-more button-loadmore-pagination"
                    onClick={() => setSkip(skip + perPage)}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Load More"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </Box>
      </Slide>
    </>
  );
};

export default MLeadsProspectsInnerTable;
